"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmDatepicker = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_hook_breakpoints_1 = __importStar(require("react-hook-breakpoints"));
const Icon_1 = require("../Icon");
const Calendar_1 = require("../Calendar");
const InputText_1 = require("../InputText");
const breakpoints_1 = require("../utils/breakpoints");
const useDatepicker_1 = require("./useDatepicker");
const hooks_1 = require("../utils/hooks");
exports.SmDatepicker = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, labelIcon, message, disabled, srOnly, icon, iconLabel, className, value, state, sizeInput, components, showDaysOutsideCurrentMonth, loading, disableFuture, disablePast, highlightToday, disableWeekends, disabledDates, disableHolidays, disableWeekDays, showHolidays, 
    //      multiCalendar,
    maxDate, minDate, locale, onSelectDate, onMonthChange } = _a, props = __rest(_a, ["id", "label", "labelIcon", "message", "disabled", "srOnly", "icon", "iconLabel", "className", "value", "state", "sizeInput", "components", "showDaysOutsideCurrentMonth", "loading", "disableFuture", "disablePast", "highlightToday", "disableWeekends", "disabledDates", "disableHolidays", "disableWeekDays", "showHolidays", "maxDate", "minDate", "locale", "onSelectDate", "onMonthChange"]);
    const { show, calendarValue, dropRef, maskValue, maskRef, onMaskChange, onSelectCalendarDate, setShow, } = (0, useDatepicker_1.useDatepicker)(ref, { start: value } || undefined);
    const datepickerClassName = (0, classnames_1.default)('c-datepicker', {
        '-show': show,
    });
    const datepickerId = (0, hooks_1.useGenerateId)(id || 'datepicker-');
    const dateIcon = react_1.default.useMemo(() => icon || react_1.default.createElement(Icon_1.SmIcon, { name: "date_range" }), [icon]);
    return (react_1.default.createElement("div", { ref: dropRef },
        react_1.default.createElement(InputText_1.SmInputText, Object.assign({}, props, { id: datepickerId, ref: maskRef, label: label, labelIcon: labelIcon, state: state, sizeInput: sizeInput, message: message, disabled: disabled, className: className, srOnly: srOnly, icon: dateIcon, value: maskValue, iconLabel: iconLabel, autoComplete: "off", onChange: (e) => {
                var _a;
                onMaskChange(e);
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.start, e);
            }, onFocus: (e) => {
                var _a;
                setShow(true);
                (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }, onIconClick: (e) => {
                var _a;
                setShow(!show);
                (_a = props.onIconClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            } }), show && (react_1.default.createElement(react_hook_breakpoints_1.default, { breakpoints: breakpoints_1.breakpoints },
            react_1.default.createElement(react_hook_breakpoints_1.MatchBreakpoint, { min: "xs" },
                react_1.default.createElement("div", { className: datepickerClassName },
                    react_1.default.createElement(Calendar_1.SmCalendar, { value: calendarValue, components: components, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, loading: loading, multiCalendar: sizeInput === 'large', disableFuture: disableFuture, "aria-selected": sizeInput === 'large', disablePast: disablePast, highlightToday: highlightToday, disableWeekends: disableWeekends, disableWeekDays: disableWeekDays, disabledDates: disabledDates, disableHolidays: disableHolidays, showHolidays: showHolidays, maxDate: maxDate, minDate: minDate, locale: locale, onMonthChange: onMonthChange, onSelectDate: (dateValue, event) => {
                            onSelectCalendarDate(dateValue);
                            onSelectDate === null || onSelectDate === void 0 ? void 0 : onSelectDate(dateValue, event);
                        } }))))))));
});
//# sourceMappingURL=index.js.map